import { useEffect, useState } from "react";
import { Building2, GraduationCap, Bot, Coins } from "lucide-react";
import { api } from "../../lib/api";

export default function Dashboard() {
    const [data, setData] = useState(null);
    useEffect(() => {
        api.get("/dashboards/me").then((r) => setData(r.data));
    }, []);
    if (!data) return <div className="p-6 text-edu-muted">Cargando…</div>;
    const { user, stats } = data;

    return (
        <div className="p-6 md:p-10 fade-in" data-testid="ejecutivo-dashboard">
            <h1 className="text-3xl font-semibold mb-1">Panel Ejecutivo</h1>
            <p className="text-edu-body mb-7">Visión global de la plataforma.</p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
                <Stat icon={Building2} label="Colegios activos" value={stats.total_schools} />
                <Stat icon={GraduationCap} label="Estudiantes" value={stats.total_students} />
                <Stat icon={Bot} label="Sesiones IA hoy" value={stats.ai_sessions_today} />
                <Stat icon={Coins} label="Monedas (mes)" value={stats.coins_consumed_month} gold />
            </div>
        </div>
    );
}

function Stat({ icon: Icon, label, value, gold }) {
    return (
        <div className={`${gold ? "bg-edu-gold text-[#0A0A0A]" : "edu-card"} p-6`}>
            <Icon size={22} className={gold ? "text-[#0A0A0A]" : "text-edu-navy"} />
            <div
                className={`text-xs uppercase tracking-widest font-semibold mt-3 ${gold ? "opacity-70" : "text-edu-muted"}`}
            >
                {label}
            </div>
            <div className="text-3xl font-bold mt-1">{value}</div>
        </div>
    );
}
